import { api } from "@/lib/api";

const d = (r) => r.data;
export const getAccount = (uid) => api.get(`/admin/accounts/${uid}`).then(d);
export const editAccountContact = (uid, body) => api.patch(`/admin/accounts/${uid}/contact`, body).then(d);
export const changeRole = (uid, body) => api.post(`/admin/accounts/${uid}/role`, body).then(d);
export const changeStatus = (uid, body) => api.post(`/admin/accounts/${uid}/status`, body).then(d);
export const softDelete = (uid, body) => api.post(`/admin/accounts/${uid}/delete`, body).then(d);
export const restoreAccount = (uid, body) => api.post(`/admin/accounts/${uid}/restore`, body).then(d);
export const purgePreview = (uid) => api.get(`/admin/accounts/${uid}/purge-preview`).then(d);
export const purgeAccount = (uid, confirm_email) => api.post(`/admin/accounts/${uid}/purge`, { confirm_email }).then(d);
export const resendLink = (uid) => api.post(`/admin/accounts/${uid}/resend-link`).then(d);
